import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import SettingReducer from "./SettingReducer";
import GlobalSearchReducer from "./GlobalSearchReducer";

const reducers = combineReducers({
  auth: AuthReducer,
  setting: SettingReducer,
  search: GlobalSearchReducer
});

export default reducers;